export class Dictionary<T> {
  public constructor(obj?: any) {
    if (obj && obj['dict']) obj = obj['dict'];
    if (obj && obj instanceof Object) {
      const keys = Object.keys(obj);
      for (const key of keys) {
        this.set(key, obj[key]);
      }
    }
  }

  private dict: Record<string, T> = {};

  get(key: string): T {
    return this.dict[key];
  }

  set(key: string, value: T) {
    this.dict[key] = value;
  }

  contains(key: string) {
    return typeof this.dict[key] !== 'undefined' && this.dict[key] !== null;
  }

  remove(key: string) {
    delete this.dict[key];
  }

  get keys(): string[] {
    return Object.keys(this.dict);
  }

  get count(): number {
    return this.keys.length;
  }

  find<T>(dict: Record<string, T>, fn: (item: T) => boolean): T | undefined {
    for (const key of Object.keys(dict)) {
      const item = dict[key];
      if (fn(item)) return item;
    }
    return undefined;
  }
}
